document.addEventListener("DOMContentLoaded", async function () {
  await renderAnnouncementBarWithCustomDiscount();
});

async function renderAnnouncementBarWithCustomDiscount() {
  const announcementBarText = document.querySelector(".announcement-bar .announcement-bar__text p");
  const announcementBarTextList = document.querySelectorAll(".announcement-bar .Marquee-tag p");

  if (!announcementBarText && !(announcementBarTextList && announcementBarTextList.length) ) return;

  const coupon = await getCoupon();
  if ( coupon ) {
    if (announcementBarText) {
      let content = announcementBarText.textContent;
      const updatedContent = content.replace(/\d+%/, `${coupon}%`);
      announcementBarText.textContent = updatedContent;
    } else {
      announcementBarTextList.forEach((element) => {
        let content = element.textContent;
        const updatedContent = content.replace(/\d+%/, `${coupon}%`);
        element.textContent = updatedContent;
      });
    }
  }
}

function mbGetCookie(name) {
  const match = document.cookie.match('(^|;)\\s*' + name + '\\s*=\\s*([^;]+)');
  return match ? match.pop() : '';
}

async function getCoupon() {
  let discountCode = mbGetCookie( 'discount_code' );
  let store = Shopify.shop;
  // let store = '974fe1'; // for testing in development only
  let body = JSON.stringify(discountCode);
  body = new URLSearchParams({ body });
  
  if (store && body) {
    const response = await fetch(`https://netlify.blacklemon.dk/.netlify/functions/checkCouponCode?store=${store}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: body,
    });

    const data = await response.json();
    if (data && data.success) {
      return data.success;
    } else {
      return false;
    }
  }
}